import { render, staticRenderFns } from "./RegisterFormV2.vue?vue&type=template&id=751c813a&scoped=true&"
import script from "./RegisterFormV2.vue?vue&type=script&lang=js&"
export * from "./RegisterFormV2.vue?vue&type=script&lang=js&"
import style0 from "./RegisterFormV2.vue?vue&type=style&index=0&id=751c813a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751c813a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RegisterFormFirstStep: require('/workspace/components/Register/RegisterFormFirstStep.vue').default,RegisterFormLocalFinalStep: require('/workspace/components/Register/RegisterFormLocalFinalStep.vue').default,RegisterFormForeignFinalStep: require('/workspace/components/Register/RegisterFormForeignFinalStep.vue').default})
